/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowaddgerman3Inputs */

const en_aiflowaddgerman3 = /** @type {(inputs: Aiflowaddgerman3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German version`)
};

const de_aiflowaddgerman3 = /** @type {(inputs: Aiflowaddgerman3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsche Fassung`)
};

/**
* | output |
* | --- |
* | "German version" |
*
* @param {Aiflowaddgerman3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaddgerman3 = /** @type {((inputs?: Aiflowaddgerman3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaddgerman3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaddgerman3(inputs)
	return de_aiflowaddgerman3(inputs)
});
export { aiflowaddgerman3 as "aiFlowAddGerman" }